import styled from "styled-components";

export const StyledContainer = styled.div`
  padding: 0;
  margin: 20px auto;
`;

export const StyledUI = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: 768px) {
    flex-direction: row;
    flex-wrap: wrap;
  }
`;

export const StyledSummaryBox = styled.div`
  background: rgba(190, 190, 230, 1);
  padding: 1rem;
  margin: 15px 0 2rem;

  h3 {
    font-size: 1.33rem;
    text-transform: uppercase;
    color: #333;
  }

  div.items {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;

    div {
      font-size: 1rem;
      line-height: 1.5;
      margin: 1rem 1rem 0;
      color: #444;
      font-weight: 600;
      text-transform: uppercase;

      span {
        color: #b11;
      }
    }
  }
`;

export const StyledOptionsMenu = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 10px 0 0;
  background-color: rgba(210, 210, 210, 0.5);
  border: 1px solid rgba(90, 90, 200, 0.4);
  padding: 20px;
  color: rgba(30, 30, 30, 1);

  h3.control-title {
    font-size: 14px;
    text-transform: uppercase;
    background: rgba(30, 30, 30, 0.6);
    padding: 10px;
    margin: 0 0 20px;
    color: #eee;
  }

  div.main-options {
    margin: 0 0 24px;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;

    div.opt {
      margin: 0 0 10px;

      @media (min-width: 992px) {
        margin: 0 0 10px;
      }

      label {
        font-weight: 700;
      }

      select {
        margin: 0 0 0 5px;
        padding: 6px 8px;
        color: #222;
      }
    }
  }

  div.ta-controls {
    margin: 0 0 24px;
    padding: 12px;
    background: rgba(100, 100, 100, 0.3);

    h4 {
      font-size: 15px;
      margin: 0 0 6px;
      text-transform: uppercase;
    }

    p {
      font-size: 13px;
      margin: 0 0 16px;
      font-weight: 400;
      font-style: italic;
    }

    div.inner {
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      justify-content: space-between;

      div.opt {
        margin: 0 0 10px;

        @media (min-width: 992px) {
          margin: 0 0 10px;
        }

        label {
          font-weight: 700;
          font-size: 14px;
        }

        select {
          margin: 0 0 0 5px;
          padding: 6px 8px;
          color: #222;
        }
      }
    }
  }

  div.loc-options {
    width: 100%;

    p {
      margin: 0 0 6px;
    }

    select {
      width: calc(100% - 8px);
      margin: 4px;
      padding: 6px 8px;
      color: #222;

      @media (min-width: 560px) {
        width: calc(100% - 50px);
      }

      @media (min-width: 768px) {
        width: calc(100% - 20px);
      }
    }
  }

  p {
    margin: 0;
    padding: 0;
    line-height: 1;
    font-weight: 700;
    text-align: left;

    &.fineprint {
      padding: 20px 0 0;
      font-size: 11px;
      font-weight: 500;
    }
  }

  div.statesBox,
  div.countriesBox {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    @media (min-width: 560px) {
      flex-direction: row;
      flex-wrap: wrap;
    }

    @media (min-width: 1100px) {
      align-items: flex-start;
      justify-content: space-between;
    }

    div.select-row {
      align-items: center;
      display: flex;
      flex-direction: row-reverse;
      justify-content: flex-start;
      flex-wrap: nowrap;
      margin-bottom: 6px;
      width: 100%;

      @media (min-width: 768px) {
        width: calc(50% - 5px);
      }

      button {
        display: block;
        background-color: rgba(92, 23, 134, 1);
        color: #eee;
        font-size: 11px;
        border: 1px solid rgba(150, 30, 200, 0.7);
        line-height: 1;
        margin-left: 1px;
        padding: 11px 6px;

        &:hover {
          background-color: rgba(102, 33, 144, 1);
          color: #fff;
          cursor: pointer;
        }
      }
    }
  }
`;

export const StyledGraphHolder = styled.div`
  width: 100%;
  margin: 10px 0 0;
  padding: 0 20px 0 0;
`;

export const StyledCountyDiv = styled.div`
  margin: 20px 0;
  padding: 20px;
  border: 1px solid blueviolet;

  h2 {
    margin: 0 0 10px;
    padding: 0;
    text-align: center;
  }

  div.countyFlexUI {
    display: flex;
    flex-direction: column;

    div.leftside {
    }

    div.rightside {
      width: 100%;
    }
  }
`;

export const StyledCountyResults = styled.div`
  margin: 0 0 10px;
  padding: 10px;
  text-align: center;

  p {
    font-size: 13px;
    margin: 6px 0 0;
    padding: 4px 0;
  }

  ul {
    margin: 0;
    padding: 0;
    list-style: none;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;

    li {
      margin: 5px;
      border: 1px solid #999;
    }
  }
`;

export const StyledCountySearch = styled.div`
  margin: 1rem 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  input {
    padding: 6px 8px;

    &:focus {
      border: 1px solid rgba(102, 43, 144, 1);
    }
  }
`;

export const StyledCountySummary = styled.div`
  background: rgba(10, 10, 20, 0.1);
  padding: 1rem;
  margin: 0 0 0.5rem;

  h3 {
    font-size: 1.1rem;
    text-transform: uppercase;
    color: #aaa;
    color: #39427d;
  }

  div.items {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;

    div {
      font-size: 1rem;
      line-height: 1.25;
      margin: 0.9rem 0.9rem 0;
      color: #b12bff;
      font-weight: 600;
      text-transform: uppercase;

      span {
        color: #333;
      }
    }
  }
`;
